var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"margin-top":"10px","cursor":"pointer"},attrs:{"src":_vm.appleImageSrc,"alt":""},on:{"click":_vm.appleLogin}})
}
var staticRenderFns = []

export { render, staticRenderFns }